import { forwardRef, type SVGAttributes } from 'react';
import { cn } from '../../utils/cn';
import { ICON_PATHS, type IconName } from './iconPaths';

export type { IconName };

export interface IconProps extends Omit<SVGAttributes<SVGSVGElement>, 'name' | 'width' | 'height'> {
    name: IconName;
    /** Sets width/height only — colour comes entirely from `currentColor`. */
    size?: number;
    /** When given, the icon becomes `role="img"` with this accessible name. */
    title?: string;
}

const DEFAULT_SIZE = 20;

export const Icon = forwardRef<SVGSVGElement, IconProps>(function Icon(
    { name, size = DEFAULT_SIZE, title, className, ...rest },
    ref,
) {
    return (
        <svg
            ref={ref}
            viewBox="0 0 24 24"
            width={size}
            height={size}
            stroke="currentColor"
            fill="none"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth={1.8}
            className={cn(className)}
            aria-hidden={title ? undefined : 'true'}
            role={title ? 'img' : undefined}
            {...rest}
        >
            {title && <title>{title}</title>}
            {ICON_PATHS[name]}
        </svg>
    );
});

export default Icon;
